import { render, staticRenderFns } from "./ReportContent.vue?vue&type=template&id=10560132&scoped=true&"
import script from "./ReportContent.vue?vue&type=script&lang=js&"
export * from "./ReportContent.vue?vue&type=script&lang=js&"
import style0 from "./ReportContent.vue?vue&type=style&index=0&id=10560132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10560132",
  null
  
)

export default component.exports